import { render, staticRenderFns } from "./SettingsSliderFramedIcon.vue?vue&type=template&id=0903238c&scoped=true&"
import script from "./SettingsSliderFramedIcon.vue?vue&type=script&lang=js&"
export * from "./SettingsSliderFramedIcon.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSliderFramedIcon.vue?vue&type=style&index=0&id=0903238c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0903238c",
  null
  
)

export default component.exports